// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"9f2021ec","391":"0784893e","569":"d594cd69","754":"d7975727","866":"aafa608c","913":"b8136bfc","958":"bc690f23"}[chunkId] + ".chunk.js";
};